<!-- ============================================================== -->
    <!-- Main wrapper - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <div id="main-wrapper">

      <app-header></app-header>

      <app-sidebar></app-sidebar>

      <div class="page-wrapper">

        <div class="container-fluid">
          <app-breadcrumbs></app-breadcrumbs>

           <!-- Start Page Content -->
                <!-- ============================================================== -->
               <router-outlet></router-outlet>
              <!-- ============================================================== -->
              <!-- End PAge Content -->


        </div>

      </div>
    </div>
